import { render, staticRenderFns } from "./widgetPiechart.vue?vue&type=template&id=37b1b5a7&scoped=true"
import script from "./widgetPiechart.vue?vue&type=script&lang=js"
export * from "./widgetPiechart.vue?vue&type=script&lang=js"
import style0 from "./widgetPiechart.vue?vue&type=style&index=0&id=37b1b5a7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1b5a7",
  null
  
)

export default component.exports